import { Switch } from "react-migration/components/Switch";
import { Theme } from "react-migration/lib/theme/Theme";
import { FC } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Tooltip } from "react-migration/components/Tooltip";
import { Checkbox } from "react-migration/components/Checkbox/Checkbox";
import clsx from "clsx";

export interface FilterNewBuildsProps {
  disabled?: boolean;
  showNewBuildOnly: boolean;
  setShowNewBuildOnly: (value: boolean) => void;
  theme?: Theme;
}

export const FilterNewBuilds: FC<FilterNewBuildsProps> = ({
  disabled,
  showNewBuildOnly,
  setShowNewBuildOnly,
  theme = Theme.Light,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1" data-testid="filter-new-builds">
      <h4 className={clsx("m-0!", disabled && "text-text-base-primary-disabled")}>
        {t("comparables.map.sidebar.filters.filters.newbuild.label")}
      </h4>
      <div className="flex items-center">
        <Checkbox
          disabled={disabled}
          id="new-builds-only"
          checked={showNewBuildOnly}
          onCheckedChange={() => setShowNewBuildOnly(!showNewBuildOnly)}
          size="sm"
        />

        <label
          htmlFor="new-builds-only"
          className={`pl-2 flex items-center ${
            disabled ? `text-text-base-primary-disabled-${theme === Theme.Light ? "light" : "dark"}` : ""
          }`}
        >
          <span className="pr-2 text-xs">{t("comparables.map.sidebar.filters.filters.newbuild")}</span>
          <Tooltip.Wrapper>
            <Tooltip.Portal>
              <Tooltip.Content size="sm" side="top" align="center" theme={Theme.Light}>
                <Tooltip.Description>
                  {t("comparables.map.sidebar.filters.filters.newbuild.tooltip")}
                </Tooltip.Description>
              </Tooltip.Content>
            </Tooltip.Portal>
            <Tooltip.Trigger>
              <i className="icon-lt-information-line cursor-pointer" />
            </Tooltip.Trigger>
          </Tooltip.Wrapper>
        </label>
      </div>
    </div>
  );
};
